/* eslint-disable max-len */
import React from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardHeader, CCardBody,
  CBreadcrumb, CBreadcrumbItem
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { createCompositionRequestAction } from '../../store/composition/compositionActions';
import CompositionInputs from '../../components/CompositionInputs/CompositionInputs';
import { useTranslation } from '../../hooks/useTranslation';

const CreateComposition = ({ createCompositionRequest, isLoading, createCompositionData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = (data) => {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const sessionUserId = localStorage.getItem('sessionUserId');
    const userId = sessionUserId || userData?.sessionUserId;

    if (userId && userId !== 'undefined') {
      createCompositionRequest({ data: { ...data, SessionUserId: String(userId) }, navigate });
    } else {
      console.error('User session not found');
    }
  };

  const handleCancel = () => {
    navigate('/composition');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/composition" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          {t('compositions')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createComposition')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('createComposition')}</h4></CCardHeader>
            <CCardBody>
              <CompositionInputs
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                isLoading={isLoading}
                submitResponse={createCompositionData}
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  createCompositionData: state.compositionReducer.createCompositionData,
});

const mapDispatchToProps = (dispatch) => ({
  createCompositionRequest: (payload) => dispatch(createCompositionRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateComposition);
